module.exports = __webpack_public_path__ + "static/media/momo5.53485659.jpg";